module.exports = __webpack_public_path__ + "static/hauwa-c572c4d919d0517cd28ca2b38801611e.jpg";